import React, { useState } from 'react';

import { requestNewPassword } from 'src/api/user-auhtentication';
import { ErrorMessage } from 'src/common/components/error-message/error-message';
import { withProviders } from 'src/common/hocs/with-providers';

import './sign-in.css';

const Recover = () => {
  const [result, setResult] = useState<boolean>();
  const [email, setEmail] = useState<string>();
  const [error, setError] = useState<string>();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(undefined);

    if (!email) {
      setError('Email is required');
      return;
    }

    requestNewPassword(email)
      .then((result) => {
        setResult(result);
        if (!result) {
          setError('Sorry, we could not recover your account.');
        }
      })
      .catch((error) =>
        setError(error.message || 'Something went wrong. Please try again.')
      );
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.currentTarget.value);
  };

  return (
    <div className="card recover">
      <h1>Recover your account</h1>

      {result === true ? (
        <div>
          <p>An email has been sent, please check your inbox.</p>
          <a href="/">Go home</a>
        </div>
      ) : (
        <div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                onChange={handleEmailChange}
              />
            </div>
            {error && (
              <ErrorMessage
                className="recover__error-message"
                message={error}
                hideIcon={true}
              />
            )}
            <button type="submit" className="blue-button">
              Recover
            </button>
            <div style={{ clear: 'both' }} />
          </form>
          <div style={{ marginTop: '15px' }}>
            Please enter the email address that was used during sign up to
            recover your account.
          </div>
        </div>
      )}
    </div>
  );
};

export default withProviders({ design: 'v1' })(Recover);
